/* eslint-disable-next-line no-restricted-syntax
-- TODO: Suppression added when adding rule to recommend avoiding enums. Enums generate a lot of bundle size bloat, please consider moving to an alternate pattern. */
export var HostActivity;
(function (HostActivity) {
    /**
     * This activity represents the step where host apps might need to fetch some user's drive
     * related information during creation or load of a fluid component.
     */
    HostActivity["GetDriveInfo"] = "GetDriveInfo";
    /**
     * In case of create flow, host apps await attach to connect new in-memory container to the storage
     */
    HostActivity["AttachContainer"] = "AttachContainer";
    /**
     * In case of create flow, host apps await getAbsoluteUrl to get a rename-resistant fluid file link.
     */
    HostActivity["GetFileLink"] = "GetFileLink";
    /**
     * Activity to measure creation of a sharing link for sharing the fluid component with other user's.
     */
    HostActivity["CreateShareLink"] = "CreateShareLink";
    /**
     * Track the render step through the following activity type.
     */
    HostActivity["RenderComponent"] = "RenderComponent";
})(HostActivity || (HostActivity = {}));
/**
 * HostActivityNameOverrides is used for activities for which we prefer to have table names which are different from the activity name.
 */
export const HostActivityNameOverrides = {
    RenderComponent: 'RenderComponentByHost'
};
//# sourceMappingURL=HostActivity.js.map